export default __webpack_public_path__ + "static/media/didimogroupshot.9ac4e633.png";